var _circle, _path, _rect, _g, _g2, _g3, _g4, _g5, _g6, _circle2, _circle3, _g7, _g8, _g9, _path2, _ellipse, _ellipse2, _g0, _g1, _path3, _g10, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg404 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 318,
  height: 318,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 159,
  r: 159,
  fill: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F7F7FC",
  d: "M95.595 252C77.047 252 59 255.441 59 259.647c0 6.882 36.595 4.206 44.114 4.206s31.08-1.912 45.618-2.294c14.537-.383 21.555 3.441 43.612 3.441s21.556-3.441 29.577-5.353c8.02-1.912 27.571.382 27.07-3.441-.401-3.059-7.854-4.079-11.53-4.206z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 164.889,
  height: 7,
  x: 93,
  y: 88,
  fill: "#D9DBE9",
  rx: 3.5
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#404_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#D9DBE9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M111 95c-5.143 6.29-9.257 16.355-9.771 23.274s0 8.807 0 15.726"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#404_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#D9DBE9",
  strokeLinecap: "round",
  strokeWidth: 6,
  d: "M139 174.5s2 8.5 0 13-13.5 13.5-13.5 13.5"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#404_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#D9DBE9",
  strokeLinecap: "round",
  strokeWidth: 6,
  d: "M114.5 175s-3.5 9.5-5.5 14-9 13-9 13"
}))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#404_svg__d)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#D9DBE9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M132.5 141.5c4.5-4 8-9.5 8-12.5"
}))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#404_svg__e)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 87,
  height: 43,
  x: 93.129,
  y: 127,
  fill: "#9298B9",
  rx: 21.5,
  transform: "rotate(15 93.13 127)"
}))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#404_svg__f)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 54,
  height: 31,
  x: 117,
  y: 100,
  fill: "#9298B9",
  rx: 15.5
}))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 133.464,
  cy: 100.464,
  r: 4,
  fill: "#9298B9",
  transform: "rotate(-30 133.464 100.464)"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 152.392,
  cy: 100.464,
  r: 4,
  fill: "#9298B9",
  transform: "rotate(-30 152.392 100.464)"
})), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#404_svg__g)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#9298B9",
  d: "M93 205.2a7.2 7.2 0 0 1 7.2-7.2h8.6a7.2 7.2 0 0 1 7.2 7.2 1.8 1.8 0 0 1-1.8 1.8H94.8a1.8 1.8 0 0 1-1.8-1.8"
}))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#404_svg__h)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#9298B9",
  d: "M119 205.2a7.2 7.2 0 0 1 7.2-7.2h8.6a7.2 7.2 0 0 1 7.2 7.2 1.8 1.8 0 0 1-1.8 1.8h-19.4a1.8 1.8 0 0 1-1.8-1.8"
}))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#404_svg__i)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 96,
  r: 8,
  fill: "#9298B9"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#223",
  d: "M136 112.5a7.5 7.5 0 0 1 7.5-7.5h15a7.5 7.5 0 0 1 0 15h-15a7.5 7.5 0 0 1-7.5-7.5"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 143.143,
  cy: 112.5,
  fill: "#D9DBE9",
  rx: 3.571,
  ry: 3.75
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 158.857,
  cy: 112.5,
  fill: "#D9DBE9",
  rx: 3.571,
  ry: 3.75
})), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#404_svg__j)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#D9DBE9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M162 158.977c19 0 27-34.977 36.5-34.977"
}))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#404_svg__k)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 198,
  cy: 123,
  r: 8,
  fill: "#9298B9"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#D9DBE9",
  d: "M85 212h10l-10 45H75zM142 212h10l10 45h-10z"
})), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#404_svg__l)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#D9DBE9",
  d: "M81 217c0-5.523 4.477-10 10-10h55c5.523 0 10 4.477 10 10v4H81z"
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#D9DBE9",
  d: "M80 238h75v9H80z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#B37196",
  d: "M233 60h9v28h-9z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#594D6B",
  d: "M227 54h6v34h-6z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#594D6B",
  d: "m221.747 54.131 5.644 2.037-11.544 31.98-5.643-2.037z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "404_svg__a",
  width: 15.997,
  height: 45,
  x: 98.003,
  y: 92,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_169_413"
})), /*#__PURE__*/React.createElement("filter", {
  id: "404_svg__b",
  width: 20.39,
  height: 32.501,
  x: 122.5,
  y: 171.499,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_169_413"
})), /*#__PURE__*/React.createElement("filter", {
  id: "404_svg__c",
  width: 20.501,
  height: 33.001,
  x: 97,
  y: 171.999,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_169_413"
})), /*#__PURE__*/React.createElement("filter", {
  id: "404_svg__d",
  width: 14,
  height: 18.5,
  x: 129.5,
  y: 126,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_169_413"
})), /*#__PURE__*/React.createElement("filter", {
  id: "404_svg__e",
  width: 85.511,
  height: 54.399,
  x: 86.827,
  y: 131.827,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  operator: "dilate",
  radius: 14,
  result: "effect1_innerShadow_169_413"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 30,
  dy: -5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_169_413"
})), /*#__PURE__*/React.createElement("filter", {
  id: "404_svg__f",
  width: 54,
  height: 31,
  x: 117,
  y: 100,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  operator: "dilate",
  radius: 5,
  result: "effect1_innerShadow_169_413"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 14,
  dy: -4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_169_413"
})), /*#__PURE__*/React.createElement("filter", {
  id: "404_svg__g",
  width: 23,
  height: 9,
  x: 93,
  y: 198,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 5,
  dy: -3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_169_413"
})), /*#__PURE__*/React.createElement("filter", {
  id: "404_svg__h",
  width: 23,
  height: 9,
  x: 119,
  y: 198,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 5,
  dy: -3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_169_413"
})), /*#__PURE__*/React.createElement("filter", {
  id: "404_svg__i",
  width: 16,
  height: 16,
  x: 101,
  y: 88,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 3,
  dy: -3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_169_413"
})), /*#__PURE__*/React.createElement("filter", {
  id: "404_svg__j",
  width: 42.5,
  height: 40.977,
  x: 159,
  y: 121,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_169_413"
})), /*#__PURE__*/React.createElement("filter", {
  id: "404_svg__k",
  width: 16,
  height: 16,
  x: 190,
  y: 115,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_169_413"
})), /*#__PURE__*/React.createElement("filter", {
  id: "404_svg__l",
  width: 75,
  height: 14,
  x: 81,
  y: 207,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_169_413"
})))));
export default Svg404;